'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classAssessment = function classAssessment() {
  return import('@/page/class/class-assessment');
};
var assessmentResultSuccess = function assessmentResultSuccess() {
  return import('@/page/class/class-assessment/assessment-result');
};
exports.default = [{
  path: '/classAssessment',
  name: 'classAssessment',
  component: classAssessment
}, {
  path: '/assessmentResultSuccess',
  name: 'assessmentResultSuccess',
  component: assessmentResultSuccess
}];